export const toggleFlag = <T extends string>(
  list: T[],
  flag: T,
  enabled: boolean,
): T[] => {
  const s = new Set(list);
  enabled ? s.delete(flag) : s.add(flag);
  return [...s];
};
